import { useState } from "react"
import { useProjects } from "../contexts/ProjectContext"
import { Building2, Newspaper, FileText, Tag } from "lucide-react"
import BusinessPage from "./onboarding/Business"
import BlogPage from "./onboarding/Blog"
import ArticlesPage from "./onboarding/Article"
import KeywordsPage from "./onboarding/Keywords"

const Settings = () => {
  const [activeTab, setActiveTab] = useState("business")
  const { currentProject } = useProjects()

  const tabs = [
    { id: "business", label: "Business", icon: Building2, description: "Company information and branding" },
    { id: "blog", label: "Blog", icon: Newspaper, description: "Blog settings and preferences" },
    { id: "articles", label: "Articles", icon: FileText, description: "Article management and configuration" },
    { id: "keywords", label: "Keywords", icon: Tag, description: "Keywords and region management" },
  ]

  const renderTabContent = () => {
    switch (activeTab) {
      case "business":
        return <BusinessPage isSettings={true} />
      case "blog":
        return <BlogPage isSettings={true} />
      case "articles":
        return <ArticlesPage isSettings={true} />
      case "keywords":
        return <KeywordsPage isSettings={true} />
      default:
        return null
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(0,0,0,0.02)_1px,transparent_0)] [background-size:24px_24px] pointer-events-none"></div>

      <div className="relative w-full">
        {/* Header */}
        <div className="px-4 py-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">Project Settings</h1>
          <p className="text-gray-600">Configure your project settings and preferences</p>
        </div>

        {/* Main Content */}
        <div className="bg-white">
          {/* Tab Navigation */}
          <div className="bg-white border-b border-gray-200/80">
            <nav className="flex" aria-label="Tabs">
              {tabs.map((tab) => {
                const Icon = tab.icon
                const isActive = activeTab === tab.id

                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`relative flex-1 min-w-[200px] p-4 transition-colors ${
                      isActive
                        ? "bg-gradient-to-r from-primary-50 to-transparent text-primary-700 border-b-2 border-primary-500"
                        : "text-gray-600 hover:bg-gray-50/80 border-b-2 border-transparent"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <Icon className={`w-5 h-5 ${isActive ? "text-primary-500" : "text-gray-400"}`} />
                      <div className="text-left">
                        <div className={`font-semibold text-sm ${isActive ? "text-primary-700" : "text-gray-800"}`}>
                          {tab.label}
                        </div>
                        <div className="text-xs text-gray-500">
                          {tab.description}
                        </div>
                      </div>
                    </div>
                  </button>
                )
              })}
            </nav>
          </div>

          {/* Tab Content - No margins or padding */}
          <div className="w-full">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings
